/** Paras bill without goals, so the goals gate on the session student picker does not apply to them. */
export const canSelectStudentForSession = (student: {
  hasConfiguredGoals?: boolean;
  isPara: boolean;
}): boolean => student.hasConfiguredGoals === true || student.isPara;
